const flagMap = {
  en: '🇬🇧',
  de: '🇩🇪',
  es: '🇪🇸',
  nl: '🇳🇱',
  ru: '🇷🇺',
  it: '🇮🇹',
  fr: '🇫🇷',
  tr: '🇹🇷',
  pl: '🇵🇱',
};

const languageNames = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
  nl: 'Dutch',
  ru: 'Russian',
  it: 'Italian',
  fr: 'French',
  tr: 'Turkish',
  pl: 'Polish',
};

function LanguageFlags({ language, className = 'flex justify-center items-center gap-2 mb-3' }) {
  if (!language || !language.includes('_')) return null;

  const codes = language.split('_');

  return (
    <div className={className}>
      {codes.map((code, idx) => (
        <span key={code} className="flex items-center gap-1">
          <span className="text-2xl leading-none" title={languageNames[code] || code}>
            {flagMap[code] || code.toUpperCase()}
          </span>
          {idx < codes.length - 1 && (
            <span className="text-gray-400 mx-1">/</span>
          )}
        </span>
      ))}
    </div>
  );
}

export default LanguageFlags;
